import {
  StudyPlanActionTypes,
  IStudyPlan,
  ISetCurrentPlan,
  ISetPlansList,
  IAddPlan,
  IUpdatePlan,
  ISetLoading,
  ISetError,
  IClearError,
  IRemovePlan,
  IClearStudyPlan,
} from './types'

export const setCurrentPlan = (planId: string | null): ISetCurrentPlan => ({
  type: StudyPlanActionTypes.SET_CURRENT_PLAN,
  payload: planId,
})

export const setPlansList = (plans: IStudyPlan[]): ISetPlansList => ({
  type: StudyPlanActionTypes.SET_PLANS_LIST,
  payload: plans,
})

export const setLoading = (loading: boolean): ISetLoading => ({
  type: StudyPlanActionTypes.SET_LOADING,
  payload: loading,
})

export const setError = (error: string): ISetError => ({
  type: StudyPlanActionTypes.SET_ERROR,
  payload: error,
})

export const clearError = (): IClearError => ({
  type: StudyPlanActionTypes.CLEAR_ERROR,
})

export const removePlan = (planId: string): IRemovePlan => ({
  type: StudyPlanActionTypes.REMOVE_PLAN,
  payload: planId,
})

export const addPlan = (plan: IStudyPlan): IAddPlan => ({
  type: StudyPlanActionTypes.ADD_PLAN,
  payload: plan,
})

export const updatePlan = (plan: IStudyPlan): IUpdatePlan => ({
  type: StudyPlanActionTypes.UPDATE_PLAN,
  payload: plan,
})

export const clearStudyPlan = (): IClearStudyPlan => ({
  type: StudyPlanActionTypes.CLEAR_STUDY_PLAN,
})
